import _regenerator from "/codebuild/output/src2081543335/src/cocoo_gov/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/codebuild/output/src2081543335/src/cocoo_gov/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { getData } from "@/services/axios";

import { ref } from 'vue';
export default {
  __name: 'ForumAttachmentItem',
  props: {
    attachment: {
      type: Object,
      required: true
    }
  },
  setup: function setup(__props) {
    var props = __props;

    // @ts-check

    var isGetS3UrlRunning = ref(false);
    var getS3SignedUrl = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var newWindow, data, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (!isGetS3UrlRunning.value) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              isGetS3UrlRunning.value = true;

              //secure browserのpopup block 対策
              newWindow = window.open();
              _context.p = 2;
              _context.n = 3;
              return getData("government_forum/get_s3_signed_url?path=" + encodeURIComponent(props.attachment.object_key));
            case 3:
              data = _context.v;
              newWindow.location = data.items.s3url;
              isGetS3UrlRunning.value = false;
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              console.log(_t);
            case 5:
              return _context.a(2);
          }
        }, _callee, null, [[2, 4]]);
      }));
      return function getS3SignedUrl() {
        return _ref.apply(this, arguments);
      };
    }();
    return {
      __sfc: true,
      props: props,
      isGetS3UrlRunning: isGetS3UrlRunning,
      getS3SignedUrl: getS3SignedUrl
    };
  }
};